<template>
    <div id="app">
        <div class="header">
            <img src="./assets/warriorhead.svg" class="logo">
            <div class="title">
                <h1>WARRIOR WASH!</h1>
                <div class="tagline">Self Service Car Wash</div>
            </div>
            <div class="head-content">
                <img src="./assets/home.png" class="wash-image">
                <br/>
                309 Main St, Santa Rosa, TX 78593
                <br/>
                Open 24/7
            </div>
        </div>

        <hr/>

        <div class="content">
            <h2>$1.00 to start<br/>4 minute wash</h2>
            <img src="./assets/coins.svg" class="coins">
        </div>

        <div class="content">
            <img src="./assets/coin.svg" class="coin">
            <h2 class="inline-text">= 1 extra minute</h2>
        </div>

        <hr/>

        <div class="content">
            <h2>Choose from 9 different washes</h2>
            <v-touch class="dial-container" ref="dialbox"
                     @panstart="panStart"
                     @pan="handlePan"
                     @panend="panStop"
                     :pan-options="{ direction: 'horizontal', threshold: 50 }">
                <div :class="{'wash-dial':true,'has-selected': selectedOption !== null}" ref="dial">
                    <v-touch v-for="(option, index) in washOptions"
                             :class="{'wash-option': true, 'selected': selectedOption !== null && selectedOption.img === option.img }"
                             :style="{ transform: 'rotate('+((36 * index)+dialRotation)+'deg)'}"
                             @tap="selectOption(index)"
                             :key="index">
                        <div class="sticker" :style="{
                            transform: 'rotate('+ (-dialRotation - (36 * index)) + 'deg)',
                            'background-image': 'url(/static/' + option.img+')'
                        }"/>
                    </v-touch>
                    <div class="wash-description" v-if="selectedOption">
                        <h3>{{ selectedOption.title }}</h3>
                        <p>{{ selectedOption.content }}</p>
                    </div>
                </div>
            </v-touch>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'app',
        data() {
            return {
                dialRotation: 0,
                dragging: false,
                dragStartAngle: 0,
                rotateTimeout: 0,
                selectedOption: null,
                washOptions: {
                    0: {
                        img: 'washoptions_stop.svg',
                        title: 'Stop',
                        content: 'Turns the pump off. Use this once you\'re done washing to save water.'
                    },
                    1: {
                        img: 'washoptions_tire.svg',
                        title: 'Tire Cleaner',
                        content: 'Removes grease and oil from tires'
                    },
                    2: {
                        img: 'washoptions_bug.svg',
                        title: 'Bug Off',
                        content: 'Dissolves bugs'
                    },
                    3: {
                        img: 'washoptions_presoak.svg',
                        title: 'Pre-Soak',
                        content: 'Pre-soaks your car'
                    },
                    4: {
                        img: 'washoptions_foam.svg',
                        title: 'Foam Brush',
                        content: 'Foamy soap with a brush'
                    },
                    5: {
                        img: 'washoptions_soap.svg',
                        title: 'High Pressure Soap',
                        content: 'Soap at high pressure, why not?'
                    },
                    6: {
                        img: 'washoptions_rinse.svg',
                        title: 'High Pressure Rinse',
                        content: 'Use good ol\' water to get that baked on dirt off!'
                    },
                    7: {
                        img: 'washoptions_wax.svg',
                        title: 'Wax',
                        content: 'Seal in that new car freshness by applying wax to your car body'
                    },
                    8: {
                        img: 'washoptions_clearcoat.svg',
                        title: 'Clear coat',
                        content: 'Seal in that new car freshness by applying clear coat to your car body'
                    },
                    9: {
                        img: 'washoptions_spotfree.svg',
                        title: 'Spot-free Rinse',
                        content: 'Soft water (water free from minerals and other contaminants), leaves little to no spots after rinsing with it'
                    },
                },
                descriptions: {
                    stop: 'Turns off the pump, saves water & saves the environment'
                }
            }
        },
        methods: {
            panStart(e) {
                this.dragStartAngle = this.getCurrentAngle(e.center.x, e.center.y) - this.dialRotation
                this.dragging       = true
            },
            handlePan(e) {
                if (this.dragging) {
                    this.dialRotation = this.getCurrentAngle(e.center.x, e.center.y) - this.dragStartAngle
                }
            },
            panStop(e) {
                if (this.dragging) {
                    let currentAngle  = this.getCurrentAngle(e.center.x, e.center.y)
                    this.dialRotation = currentAngle - this.dragStartAngle
                    this.dragging     = false

                    let endRotate = (target) => {
                        clearTimeout(this.rotateTimeout)
                        if (Math.abs(target) > 0.2) {
                            this.dialRotation += target
                            this.rotateTimeout = setTimeout(() => {
                                endRotate(target - (target / 10))
                            }, 10)
                        }
                    }
                    endRotate(((currentAngle > 90 || currentAngle < -90) ? -e.velocity : e.velocity) * 5)
                }
            },
            getCurrentAngle(posX, posY) {
                let dial    = this.$refs.dial.getBoundingClientRect()
                let windowX = (dial.left + (dial.width / 2));
                let windowY = (dial.top + (dial.height / 2));
                let mouseX  = posX;
                let mouseY  = posY;
                let angle   = (-Math.atan2(windowX - mouseX, windowY - mouseY)) * (180 / Math.PI)
                return (angle)
            },
            selectOption(option) {
                this.selectedOption = this.selectedOption !== null && this.selectedOption.img === this.washOptions[option].img
                    ? null
                    : this.washOptions[option]
                let rotateTo        = -36 * option
                if ((rotateTo - this.dialRotation) > 180) {
                    this.dialRotation += 360
                } else if ((rotateTo - this.dialRotation) < -180) {
                    this.dialRotation -= 360
                }

                let rotate = (target) => {
                    clearTimeout(this.rotateTimeout)
                    let delta = this.dialRotation - target;
                    if (Math.abs(delta) > 1) {
                        this.dialRotation -= Math.round((delta / 20) * 10) / 10
                        this.rotateTimeout = setTimeout(() => {
                            rotate(target)
                        }, 4)
                    } else {
                        clearTimeout(this.rotateTimeout)
                    }
                }
                rotate(rotateTo)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// App.vue?6ba21736